export const MASTER_SECTION_IDS = ['services'] as const
export type MasterSectionId = (typeof MASTER_SECTION_IDS)[number]
